/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = ReadyToStart
 *
 * 2 = Pending
 *
 * 3 = InProcess
 *
 * 4 = Completed
 */
export enum MaintenanceTasksStatusEnum {
  ReadyToStart = 1,
  Pending = 2,
  InProcess = 3,
  Completed = 4,
}
